import { NgModule } from '@angular/core';
import { FaceToStringPipe } from './face-to-string/face-to-string';
import { TimeFormatPipe } from './time-format/time-format';
import { TimeFormatFromNowPipe } from './time-format-from-now/time-format-from-now';
import { TimeAutoFormatPipe } from './time-auto-format/time-auto-format';
import { TimediffnowPipe } from './timediffnow/timediffnow';
import { SearchChangePipe } from './search-change/search-change';
import { Duration2StrPipe, DurationPipe } from './duration/duration';
import { FileSizePipe } from './file-size/file-size';
import { GetFileImgPipe } from './get-file-img/get-file-img';
import { SortNumPipe } from './sort-num/sort-num';
import { HttpFormatPipe } from './http-format/http-format';
@NgModule({
  declarations: [
    FaceToStringPipe,
    TimeFormatPipe,
    TimeFormatFromNowPipe,
    TimeAutoFormatPipe,
    TimediffnowPipe,
    SearchChangePipe,
    DurationPipe,
    Duration2StrPipe,
    FileSizePipe,
    GetFileImgPipe,
    SortNumPipe,
    HttpFormatPipe,
  ],
  imports: [],
  exports: [
    FaceToStringPipe,
    TimeFormatPipe,
    TimeFormatFromNowPipe,
    TimeAutoFormatPipe,
    TimediffnowPipe,
    SearchChangePipe,
    DurationPipe,
    Duration2StrPipe,
    FileSizePipe,
    GetFileImgPipe,
    SortNumPipe,
    HttpFormatPipe,
  ],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts